export const fonts = {
  poppins: "font-family: 'Poppins', sans-serif;",
  arial: "font-family: Arial, sans-serif;",
  workSans: "font-family: 'Work Sans', sans-serif;",
};
